import LoadingUI from './lib/LoadingUI';

export default LoadingUI;
